<template>
    <div>
        <div style="display: flex;align-items: center;justify-content: space-between;">
            <a-breadcrumb style="margin: 16px 0">
                <a-breadcrumb-item>主页</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectFirstMenu }}</a-breadcrumb-item>
                <a-breadcrumb-item>{{ selectSecondMenu }}</a-breadcrumb-item>
            </a-breadcrumb>
            <div>
                <a-button class="qinang-button-margin" type="primary" icon="plus" @click="tableAdd">新增</a-button>
                <a-button class="qinang-button-margin" icon="edit"
                    :disabled="!tableSelectedRows || tableSelectedRows.length !== 1" @click="tableEdit()">修改</a-button>
                <a-button class="qinang-button-margin" icon="delete" @click="tableDel"
                    :disabled="!tableSelectedRows || tableSelectedRows.length === 0">删除</a-button>
                <a-button icon="sync" @click="apiPrepareQueryList">刷新</a-button>
            </div>
        </div>
        <a-collapse expandIconPosition="right" activeKey="1">
            <a-collapse-panel key="1" header="预设配置查询">
                <div class="qinang-search-row">
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">服务商：</div>
                        <a-select v-model="query.facilitatorId" show-search option-filter-prop="children"
                            :filter-option="filterOption" style="width: 100%;" placeholder="请选择服务商" allowClear>
                            <a-select-option :value="0">全部</a-select-option>
                            <a-select-option v-for="(item, index) in facilitatorList" :value="item.facilitatorId"
                                :key="index">{{ item.facilitatorName }}</a-select-option>
                        </a-select>
                    </div>
                    <div class="qinang-search-col-3">
                        <div class="qinang-search-col-title">查询名称：</div>
                        <a-input v-model="query.queryName" placeholder="请输入查询名称" />
                    </div>
                    <div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
                        <a-button type="primary" icon="search" @click="apiPrepareQueryList">查询</a-button>
                        <a-button icon="redo" style="margin-left: 14px;" @click="resetQuery">重置</a-button>
                    </div>
                </div>
            </a-collapse-panel>
        </a-collapse>

        <div class="qinang-card">
            <a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData"
                row-key="prepareQueryId" :loading="tableLoading" :pagination="false">
                <template slot="queryName" slot-scope="record">
                    <a-button type="link" @click="tableEdit(record)">{{ record.queryName || '' }}</a-button>
                </template>
                <!-- <template slot="enterpriseName" slot-scope="record">
                    {{ enterpriseMap['qy' + record.enterpriseId] || record.enterpriseId || '' }}
                </template> -->
            </a-table>
            <a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total"
                :default-page-size="query.size" show-size-changer show-quick-jumper size="small"
                :page-size-options="['10', '20', '50']" :show-total="total => `共 ${total} 条记录`" @change="pageChange"
                @showSizeChange="showSizeChange" />
        </div>
        <!-- 新增弹窗 -->
        <a-modal class="qa-modal" title="新增预设" width="960px" :visible="addVisible" :confirm-loading="addConfirmLoading"
            @ok="addHandleOk" @cancel="handleCancel" :maskClosable="false" :keyboard="false">
            <a-form-model ref="addRuleForm" :model="addForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }"
                :rules="addRules">
                <a-form-model-item label="查询名称" prop="queryName">
                    <a-input v-model="addForm.queryName" placeholder="请输入查询名称" />
                </a-form-model-item>
                <a-form-model-item label="描述">
                    <a-textarea v-model="addForm.description" :rows="2" placeholder="选填" />
                </a-form-model-item>
                <a-form-model-item label="参数配置">
                    <div style="margin-bottom: 8px;">
                        <a-button type="dashed" icon="plus" @click="addParamRow('addForm')">添加参数</a-button>
                    </div>
                    <a-table :columns="paramColumns" :data-source="addForm.paramRows" row-key="__key"
                        :pagination="false" size="small" bordered>

                        <template slot="key" slot-scope="text, record">
                            <a-input v-model="record.key" placeholder="参数key" />
                        </template>
                        <template slot="label" slot-scope="text, record">
                            <a-input v-model="record.label" placeholder="显示名" />
                        </template>
                        <template slot="type" slot-scope="text, record">
                            <a-select v-model="record.type" style="width: 100%;" placeholder="值类型">
                                <a-select-option v-for="t in typeOptions" :value="t.value" :key="t.value">{{ t.label
                                }}</a-select-option>
                            </a-select>
                        </template>
                        <template slot="input" slot-scope="text, record">
                            <a-select v-model="record.input" style="width: 100%;" placeholder="控件">
                                <a-select-option v-for="i in inputOptions" :value="i.value" :key="i.value">{{ i.label
                                }}</a-select-option>
                            </a-select>
                        </template>
                        <template slot="required" slot-scope="text, record">
                            <a-switch v-model="record.required" />
                        </template>
                        <template slot="default" slot-scope="text, record">
                            <a-switch v-if="record.input === 'switch'" v-model="record.default" />
                            <a-input v-else v-model="record.default" placeholder="默认值" />
                        </template>
                        <template slot="limit" slot-scope="text, record">
                            <a-input v-model="record.limit" placeholder="约束" />
                        </template>

                        <template slot="optionsText" slot-scope="text, record">
                            <a-textarea v-if="record.input === 'select' || record.input === 'multiple'"
                                v-model="record.optionsText" :rows="2"
                                placeholder='[{"value":"1","label":"是"},{"value":"2","label":"否"}]' />
                            <a-input v-else :value="'(仅下拉框可填)'" disabled />
                        </template>
                        <template slot="paramAction" slot-scope="text, record">
                            <a-button type="link" @click="delParamRow('addForm', record)">删除</a-button>
                        </template>
                    </a-table>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
        <!-- 修改弹窗 -->
        <a-modal class="qa-modal" title="修改预设" width="960px" :visible="editVisible"
            :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="handleCancel" :maskClosable="false"
            :keyboard="false">
            <a-form-model ref="editRuleForm" :model="editForm" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }"
                :rules="addRules">
                <a-form-model-item label="查询名称" prop="queryName">
                    <a-input v-model="editForm.queryName" placeholder="请输入查询名称" />
                </a-form-model-item>
                <a-form-model-item label="描述">
                    <a-textarea v-model="editForm.description" :rows="2" placeholder="选填" />
                </a-form-model-item>
                <a-form-model-item label="参数配置">
                    <div style="margin-bottom: 8px;">
                        <a-button type="dashed" icon="plus" @click="addParamRow('editForm')">添加参数</a-button>
                    </div>
                    <a-table :columns="paramColumns" :data-source="editForm.paramRows" row-key="__key"
                        :pagination="false" size="small" bordered>
                        <template slot="key" slot-scope="text, record">
                            <a-input v-model="record.key" placeholder="参数key" />
                        </template>
                        <template slot="label" slot-scope="text, record">
                            <a-input v-model="record.label" placeholder="显示名" />
                        </template>
                        <template slot="type" slot-scope="text, record">
                            <a-select v-model="record.type" style="width: 100%;" placeholder="值类型">
                                <a-select-option v-for="t in typeOptions" :value="t.value" :key="t.value">{{ t.label
                                }}</a-select-option>
                            </a-select>
                        </template>
                        <template slot="input" slot-scope="text, record">
                            <a-select v-model="record.input" style="width: 100%;" placeholder="控件">
                                <a-select-option v-for="i in inputOptions" :value="i.value" :key="i.value">{{ i.label
                                }}</a-select-option>
                            </a-select>
                        </template>
                        <template slot="required" slot-scope="text, record">
                            <a-switch v-model="record.required" />
                        </template>
                        <template slot="default" slot-scope="text, record">
                            <a-switch v-if="record.input === 'switch'" v-model="record.default" />
                            <a-input v-else v-model="record.default" placeholder="默认值" />
                        </template>
                        <template slot="limit" slot-scope="text, record">
                            <a-input v-model="record.limit" placeholder="约束" />
                        </template>
                        <template slot="optionsText" slot-scope="text, record">
                            <a-textarea v-if="record.input === 'select' || record.input === 'multiple'"
                                v-model="record.optionsText" :rows="2"
                                placeholder='[{"value":"1","label":"是"},{"value":"2","label":"否"}]' />
                            <a-input v-else :value="'(仅下拉框可填)'" disabled />
                        </template>
                        <template slot="paramAction" slot-scope="text, record">
                            <a-button type="link" @click="delParamRow('editForm', record)">删除</a-button>
                        </template>
                    </a-table>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>
<script>
export default {
    data() {
        return {
            selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
            selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
            facilitatorList: [],
            currentEnterpriseId: undefined,
            enterpriseList: [],
            enterpriseMap: {},
            query: {
                page: 1,
                size: 10,
                total: 0,
                queryName: undefined,
                facilitatorId: 0,
            },
            tableData: [],
            tableColumns: [
                { title: 'ID', dataIndex: 'prepareQueryId', key: 'prepareQueryId', align: 'center' },
                { title: '查询名称', key: 'queryName', align: 'center', scopedSlots: { customRender: 'queryName' } },
            ],
            tableLoading: false,
            tableSelectedRows: [],
            selectedRowKeys: [],
            paramColumns: [
                { title: '参数key', key: 'key', width: 90, scopedSlots: { customRender: 'key' } },
                { title: '显示名', key: 'label', width: 90, scopedSlots: { customRender: 'label' } },
                { title: '值类型', key: 'type', width: 80, scopedSlots: { customRender: 'type' } },
                { title: '控件', key: 'input', width: 90, scopedSlots: { customRender: 'input' } },
                { title: '必填', key: 'required', width: 50, align: 'center', scopedSlots: { customRender: 'required' } },
                { title: '默认值', key: 'default', width: 80, scopedSlots: { customRender: 'default' } },
                { title: '约束(limit)', key: 'limit', width: 80, scopedSlots: { customRender: 'limit' } },
                { title: 'options JSON', key: 'optionsText', width: 140, scopedSlots: { customRender: 'optionsText' } },
                { title: '操作', key: 'paramAction', width: 60, align: 'center', scopedSlots: { customRender: 'paramAction' } },
            ],

            inputOptions: [
                { value: 'text', label: '单行文本' },
                { value: 'textarea', label: '多行文本' },
                { value: 'number', label: '数字' },
                { value: 'select', label: '下拉单选' },
                { value: 'multiple', label: '下拉多选' },
                { value: 'switch', label: '开关(布尔)' },
                { value: 'date', label: '日期' },
                { value: 'dateTimePicker', label: '日期时间' },
                { value: 'monthPicker', label: '月份' },
                { value: 'yearPicker', label: '年份' },
            ],
            typeOptions: [
                { value: 'string', label: '字符串' },
                { value: 'number', label: '数字' },
                { value: 'boolean', label: '布尔' },
                { value: 'date', label: '日期' },
            ],
            addVisible: false,
            addConfirmLoading: false,
            addForm: this.emptyForm(),
            addRules: {
                queryName: [{ required: true, message: '查询名称不能为空', trigger: 'blur' }],
                // querySql: [{ required: true, message: 'SQL模板不能为空', trigger: 'blur' }],
            },
            editVisible: false,
            editConfirmLoading: false,
            editForm: this.emptyForm(),
        };
    },
    methods: {
        emptyForm() {
            return {
                prepareQueryId: undefined,
                queryName: '',
                description: '',
                paramRows: [],
            };
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        // 服务商下拉（查询面板占位，筛选逻辑后续实现）
        async apiFacilitatorListForStaff() {
            const { data: res } = await this.$http.post(this.navigation.apiFacilitatorListForStaff, {
                staffId: window.sessionStorage.getItem('staffId'),
            });
            if (res.code == 200) {
                this.facilitatorList = res.data || [];
            } else {
                this.$message.error(res.msg);
            }
        },
        // 当前登录员工 -> 所属企业ID（staffId 反查 enterpriseId）
        async apiStaffInfo() {
            const { data: res } = await this.$http.post(this.navigation.apiStaffList, {
                staffId: window.sessionStorage.getItem('staffId'),
            });
            if (res.code == 200) {
                const staff = Array.isArray(res.data) ? res.data[0] : res.data;
                this.currentEnterpriseId = staff ? staff.enterpriseId : undefined;
            } else {
                this.$message.error(res.msg);
            }
        },
        // 列表查询
        async apiPrepareQueryList() {
            this.tableLoading = true;
            const params = {
                page: this.query.page,
                size: this.query.size,
                queryName: this.query.queryName || undefined,
            };
            const { data: res } = await this.$http.post(this.navigation.apiPrepareQueryList, params);
            if (res.code == 200) {
                this.tableData = res.data.list || [];
                this.query.page = res.data.pages.page;
                this.query.size = res.data.pages.size;
                this.query.total = res.data.pages.total;
            } else {
                this.$message.error(res.msg);
            }
            this.tableLoading = false;
        },
        pageChange(page, pageSize) {
            this.query.page = page;
            this.query.size = pageSize;
            this.apiPrepareQueryList();
        },
        showSizeChange(current, size) {
            this.query.page = current;
            this.query.size = size;
            this.apiPrepareQueryList();
        },
        resetQuery() {
            this.query = { page: 1, size: 10, total: 0, queryName: undefined, facilitatorId: 0 };
            this.apiPrepareQueryList();
        },
        handleCancel() {
            this.addVisible = false;
            this.editVisible = false;
        },
        // paramConfig 字符串 -> 参数行数组（兼容对象/数组两种格式）
        parseParamConfig(str) {
            if (!str) return [];
            let json;
            try {
                json = JSON.parse(str);
            } catch (e) {
                this.$message.error('paramConfig JSON 解析失败');
                return [];
            }
            const arr = Array.isArray(json) ? json : Object.keys(json).map((k) => ({ key: k, ...json[k] }));
            return arr.map((it) => {
                let def = '';
                if (it.input === 'switch') {
                    // 开关：default 还原为布尔，避免 'false' 被当真值
                    def = (it.default === true || it.default === 'true') ? true
                        : (it.default === false || it.default === 'false' ? false : '');
                } else {
                    def = it.default !== undefined && it.default !== null ? String(it.default) : '';
                }
                return {
                    __key: Date.now() + Math.random(),
                    key: it.key || '',
                    label: it.label || '',
                    type: it.type || 'string',
                    input: it.input || 'text',
                    required: it.required === true,
                    default: def,
                    limit: it.limit || '',
                    optionsText: Array.isArray(it.options) ? JSON.stringify(it.options, null, 2) : (it.optionsText || ''),
                };
            });

        },
        buildParamConfig(rows) {
            const obj = {};
            for (const it of rows) {
                if (!it.key || !it.key.trim()) {
                    this.$message.error('参数 key 不能为空');
                    return null;
                }
                let options = [];
                if (it.input === 'select' || it.input === 'multiple') {
                    if (it.optionsText && it.optionsText.trim()) {
                        try {
                            options = JSON.parse(it.optionsText);
                        } catch (e) {
                            this.$message.error('参数【' + it.key + '】的 options JSON 格式错误');
                            return null;
                        }
                    }
                }
                let def = undefined;
                if (it.input === 'switch') {
                    def = (it.default === true || it.default === 'true') ? true
                        : (it.default === false || it.default === 'false' ? false : undefined);
                } else {
                    def = (it.default === '' || it.default === undefined || it.default === null) ? undefined : it.default;
                }
                obj[it.key] = {
                    label: it.label || it.key,
                    type: it.type || 'string',
                    input: it.input || 'text',
                    required: it.required === true,
                    default: def,
                    limit: it.limit || '',
                    options: options,
                };

            }
            return JSON.stringify(obj);
        },
        tableAdd() {
            this.addVisible = true;
            this.addConfirmLoading = false;
            this.addForm = this.emptyForm();
            if (this.$refs.addRuleForm) {
                this.$refs.addRuleForm.resetFields();
            }
        },
        tableEdit(row) {
            let item;
            if (row != null) {
                item = row;
            } else if (this.tableSelectedRows.length === 1) {
                item = this.tableData.find(i => i.prepareQueryId == this.selectedRowKeys[0]);
            } else {
                this.$message.warning('请选择要修改的数据');
                return;
            }
            this.editVisible = true;
            this.editConfirmLoading = false;
            this.editForm = {
                prepareQueryId: item.prepareQueryId,
                queryName: item.queryName,
                description: item.description,
                paramRows: this.parseParamConfig(item.paramConfig),
            };
            if (this.$refs.editRuleForm) {
                this.$refs.editRuleForm.clearValidate();
            }
        },
        addParamRow(formKey) {
            this[formKey].paramRows.push({
                __key: Date.now() + Math.random(),
                key: '', label: '', type: 'string', input: 'text', required: false, default: '', limit: '', optionsText: '',
            });
        },
        delParamRow(formKey, record) {
            this[formKey].paramRows = this[formKey].paramRows.filter((r) => r.__key !== record.__key);
        },
        async apiPrepareQueryAdd() {
            this.addConfirmLoading = true;
            const paramConfig = this.buildParamConfig(this.addForm.paramRows);
            if (paramConfig === null) {
                this.addConfirmLoading = false;
                return;
            }
            // if (!this.validateOptionalParams(this.addForm.querySql, this.addForm.paramRows)) {
            //     this.addConfirmLoading = false;
            //     return;
            // }
            const payload = {
                queryName: this.addForm.queryName,
                enterpriseId: this.currentEnterpriseId,
              
                description: this.addForm.description,
                paramConfig: paramConfig,
            };
            const { data: res } = await this.$http.post(this.navigation.apiPrepareQueryAdd, payload);
            if (res.code == 200) {
                this.$message.success(res.msg);
                this.addVisible = false;
                this.apiPrepareQueryList();
            } else {
                this.$message.error(res.msg);
            }
            this.addConfirmLoading = false;
        },
        addHandleOk() {
            this.$refs.addRuleForm.validate((valid) => {
                if (valid) {
                    this.apiPrepareQueryAdd();
                } else {
                    return false;
                }
            });
        },
        async apiPrepareQueryEdit() {
            this.editConfirmLoading = true;
            const paramConfig = this.buildParamConfig(this.editForm.paramRows);
            if (paramConfig === null) {
                this.editConfirmLoading = false;
                return;
            }
            // if (!this.validateOptionalParams(this.editForm.querySql, this.editForm.paramRows)) {
            //     this.editConfirmLoading = false;
            //     return;
            // }

            const payload = {
                prepareQueryId: this.editForm.prepareQueryId,
                queryName: this.editForm.queryName,
                enterpriseId: this.currentEnterpriseId,
      
                description: this.editForm.description,
                paramConfig: paramConfig,
            };
            const { data: res } = await this.$http.post(this.navigation.apiPrepareQueryEdit, payload);
            if (res.code == 200) {
                this.$message.success(res.msg);
                this.editVisible = false;
                this.apiPrepareQueryList();
            } else {
                this.$message.error(res.msg);
            }
            this.editConfirmLoading = false;
        },
        editHandleOk() {
            this.$refs.editRuleForm.validate((valid) => {
                if (valid) {
                    this.apiPrepareQueryEdit();
                } else {
                    return false;
                }
            });
        },
        async apiPrepareQueryDel(ids) {
            const { data: res } = await this.$http.post(this.navigation.apiPrepareQueryDel + '/' + ids);
            if (res.code == 200) {
                this.$message.success(res.msg);
            } else {
                this.$message.error(res.msg);
            }
            this.apiPrepareQueryList();
        },
        //   async apiEnterpriseList() {
        // },
        tableDel() {
            const that = this;
            if (this.tableSelectedRows.length === 0) {
                this.$message.warning('请选择要删除的数据');
                return;
            }
            const ids = this.tableSelectedRows.map((r) => r.prepareQueryId);
            this.$confirm({
                title: '确定要删除当前选中数据吗',
                content: '当前选中 ' + ids.length + ' 条数据。',
                okText: '确定',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    that.apiPrepareQueryDel(ids);
                },
            });
        },
        // validateOptionalParams(sql, rows) {
        //     if (!sql) return true;
        //     // 非必填参数必须在 SQL 中用 <if key> 包裹
        //     for (const it of rows) {
        //         if (it.required === true) continue;
        //         if (!it.key || !it.key.trim()) continue;
        //         const re = new RegExp('<if\\s+' + it.key.trim() + '>', 'i');
        //         if (!re.test(sql)) {
        //             this.$message.error('非必填参数【' + it.key + '】的 SQL 未用 <if ' + it.key + '>...</if> 包裹，空值时会查询全表');
        //             return false;
        //         }
        //     }
        //     //SQL 里的每个 #{key} 占位符必须在参数列表中存在
        //     const paramKeys = rows.filter((it) => it.key && it.key.trim()).map((it) => it.key.trim());
        //     const phRe = /#\{([^}]+)\}/g;
        //     let m;
        //     while ((m = phRe.exec(sql)) !== null) {
        //         const phKey = m[1].trim();
        //         if (!paramKeys.includes(phKey)) {
        //             this.$message.error('SQL 中的占位符【#{' + phKey + '}】在参数列表中不存在，请检查参数key是否一致');
        //             return false;
        //         }
        //     }
        //     return true;
        // },


    },
    computed: {
        rowSelection() {
            const that = this;
            return {
                selectedRowKeys: that.selectedRowKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                    that.selectedRowKeys = selectedRowKeys;
                    that.tableSelectedRows = selectedRows;
                },
            };
        },
    },
    created() {
        this.apiPrepareQueryList();
        this.apiFacilitatorListForStaff();
        // this.apiEnterpriseList();
        this.apiStaffInfo();
    },

};
</script>
